// extracted by mini-css-extract-plugin
export default {"ctn":"cast_ctn__KrqIR","list":"cast_list__yJ2dM","item":"cast_item__I2QWD"};